import React, { useState } from 'react';
import {
  Box, Container, Grid, Typography, Link, IconButton, Divider,
  Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';

// Icons
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const policyContent = {
  privacy: {
    title: "Privacy Policy",
    content: ""
  },
  terms: {
    title: "Terms of Service",
    content: ""
  },
  refund: {
    title: "Refund Policy",
    content: ""
  }
};

export default function Footer({ setCurrentPage }) {
  const [modalKey, setModalKey] = useState(null);

  const handleOpenPolicy = (key) => setModalKey(key);
  const handleClosePolicy = () => setModalKey(null);

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#0a0f1d',
        color: '#94a3b8',
        pt: 6,
        pb: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid className="row"  alignItems="flex-start" justifyContent="space-between">
          <Grid className="col-sm-3" item xs={12} md={6}>
            <Box
              onClick={() => setCurrentPage('home')}
              sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, cursor: 'pointer' }}
            >
              <img
                src="/logo.jpeg"
                alt="HotelZio Logo"
                style={{ width: '150px', height: '150px', borderRadius: '10px', objectFit: 'cover' }}
              />
              
            </Box>
            
           
          </Grid>

          <Grid className="col-sm-4" item xs={12} md={6}>
            <Box
              onClick={() => setCurrentPage('home')}
              sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, cursor: 'pointer' }}
            >
              <Typography variant="h5" fontWeight={800} sx={{ color: '#D4AF37', letterSpacing: '-0.5px' }}>
                Hotel<span style={{ color: '#ffffff' }}>Zio</span>
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#94a3b8', lineHeight: 1.7, mb: 2.5, maxWidth: 360 }}>
              Connecting travelers with extraordinary boutique hotels, beachfront villas, and luxury city retreats around the globe.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              {[FacebookIcon, InstagramIcon, TwitterIcon, LinkedInIcon].map((Icon, idx) => (
                <IconButton
                  key={idx}
                  size="small"
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    color: '#ffffff',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      bgcolor: '#D4AF37',
                      borderColor: '#D4AF37',
                      transform: 'translateY(-2px)'
                    },
                  }}
                >
                  <Icon fontSize="small" />
                </IconButton>
              ))}
            </Box>
          </Grid>

          <Grid className="col-sm-4" item xs={12} md={4} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Typography variant="subtitle1" fontWeight={700} color="#ffffff" sx={{ mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2, alignItems: { xs: 'flex-start', md: 'flex-end' } }}>
              {[
                { label: 'Privacy Policy', key: 'privacy' },
                { label: 'Terms of Service', key: 'terms' },
                { label: 'Refund Policy', key: 'refund' },
              ].map((item) => (
                <Link
                  key={item.key}
                  component="button"
                  underline="none"
                  onClick={() => handleOpenPolicy(item.key)}
                  sx={{
                    color: '#94a3b8',
                    fontSize: '0.95rem',
                    transition: 'all 0.2s',
                    '&:hover': { color: '#D4AF37' }
                  }}
                >
                  {item.label}
                </Link>
              ))}
            </Box>
          </Grid>

          

        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.08)' }} />

        {/* --- BOTTOM BAR --- */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
            © {new Date().getFullYear()} HotelZio Inc. All rights reserved.
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, color: '#94a3b8', fontSize: '0.85rem', cursor: 'pointer' }}>
              <LanguageRoundedIcon sx={{ fontSize: 18 }} />
              <span>English (US)</span>
            </Box>
            
          </Box>
        </Box>

      </Container>

      {/* POLICY MODAL DIALOG */}
      <Dialog
        open={Boolean(modalKey)}
        onClose={handleClosePolicy}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            bgcolor: '#0f172a',
            color: '#ffffff',
            border: '1px solid rgba(255,255,255,0.1)',
            p: 1
          }
        }}
      >
        {modalKey && (
          <>
            <DialogTitle fontWeight={800} sx={{ color: '#ffffff' }}>
              {policyContent[modalKey].title}
            </DialogTitle>
            <DialogContent>
              <Typography variant="body2" sx={{ color: '#94a3b8', lineHeight: 1.8 }}>
                {policyContent[modalKey].content}
              </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button
                onClick={handleClosePolicy}
                variant="contained"
                disableElevation
                sx={{
                  bgcolor: '#D4AF37',
                  color: '#fff',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 700,
                  '&:hover': { bgcolor: '#e0314f' },
                }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
}